export default "__VITE_ASSET__XsxXEwKC__"